/** @jsxRuntime classic */
/** @jsx jsx */
/** @jsxFrag React.Fragment */
// @ts-check
import { Text } from '@bottlebooks/gatsby-theme-base/src';
import { gql } from '@apollo/client';
import React from 'react';
import { jsx } from 'theme-ui';
import { graphql } from 'gatsby';
import EditProductInBottlebooksAction from './EditProductInBottlebooksAction';

export * from '@bottlebooks/gatsby-theme-event/src/components/Product/ProductVarieties';

export default function ProductVarieties({ product, ...rest }) {
  if (!product?.grapeVarieties) {
    return (
      <EditProductInBottlebooksAction
        product={product}
        sx={{
          position: 'absolute',
          right: 3,
          bottom: 3,
          color: 'lightestText',
        }}
      />
    );
  }

  return (
    <>
      <Text variant="smallest" sx={{ color: 'text' }} {...rest}>
        {product.grapeVarieties
          .filter(Boolean)
          .map((v) =>
            v.percentage ? `${v.percentage}% ${v.varietyName}` : v.varietyName
          )
          .join(', ')}
      </Text>
      <EditProductInBottlebooksAction
        product={product}
        sx={{
          position: 'absolute',
          left: 2,
          bottom: 2,
          color: 'lightestText',
          zIndex: 1,
        }}
      />
    </>
  );
}

export const fragment = graphql`
  fragment vv_ProductVarieties on Bottlebooks_Wine {
    grapeVarieties {
      varietyName
      percentage
    }
  }
`;

export const ProductVarietiesFragment = gql`
  fragment ProductVarieties on Wine {
    grapeVarieties {
      varietyName
      percentage
    }
  }
`;
